import { API_URL } from '@/config';

export const logout = (lang: string): Promise<null> => {
  // ログアウト直後に SPA が未ログイン扱いで /auth/login へ戻るのを防ぐため、
  // URL を変えずに「現在の履歴 state」にフラグだけ入れる（再描画/遷移なし、履歴も増えない）。
  const currentHistoryState = window.history.state ?? {};
  const nextHistoryState = { ...currentHistoryState, logoutPending: true };
  window.history.replaceState(nextHistoryState, '', window.location.href);

  // ほかのアプリからもログアウトするためにOIDCログアウトURLにリダイレクト
  // replace を使うことで戻るボタンで直前のページ（ログアウト前画面）に戻れないようにし、意図しない再表示を防ぐ
  const oidcLogoutUrl = buildOidcLogoutUrl(lang);
  window.location.replace(oidcLogoutUrl);
  return Promise.resolve(null);
};

function buildOidcLogoutUrl(lang: string): string {
  const oidcProviderBase = API_URL;
  const url = new URL('/oauth/logout', oidcProviderBase);
  url.searchParams.set('post_logout_redirect_uri', window.location.origin);
  url.searchParams.set('lang', lang);

  return url.toString();
}
